import { Injectable } from '@angular/core';
import { Core2Config } from '../../shared/core2Config';
import { HttpClient, HttpParams } from '@angular/common/http';
import { WarrantyProductRegistrationContainerModel } from '../../../../../../models/aggregates/erp/warranty';
import { ApiResponseModel, ApiVisa, BasicApiResponseModel } from '../../shared';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class WarrantyProductRegistrationService extends BaseApiPublicLoginTemplateService<WarrantyProductRegistrationContainerModel, WarrantyProductRegistrationContainerModel, WarrantyProductRegistrationContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration' + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration/' + Core2Config.LOGIN_EP_SUFFIX;
    this.endpoint_path_login_entity_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.WARRANTY_PREFIX + 'product-registration/' + Core2Config.LOGIN_ENTITY_EP_SUFFIX;
    this.httpClient = http;
  }

  postLoginEntity(dtoObject: WarrantyProductRegistrationContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<WarrantyProductRegistrationContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_entity_url;
    }
    return this.httpClient.post<BasicApiResponseModel<WarrantyProductRegistrationContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  /**Get All (Login Entity Ep) */
  getAllLoginEntity(visa: ApiVisa): Observable<ApiResponseModel<WarrantyProductRegistrationContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.get<ApiResponseModel<WarrantyProductRegistrationContainerModel>>(
      url,
      this.getHttpHeader(visa)
    );
  }

  putLoginEntity(dtoObject: WarrantyProductRegistrationContainerModel, visa: ApiVisa): Observable<BasicApiResponseModel<WarrantyProductRegistrationContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.put<BasicApiResponseModel<WarrantyProductRegistrationContainerModel>>(
      url,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  /** Delete branch */
  deleteLoginEntity(guid: string, visa: ApiVisa): Observable<ApiResponseModel<WarrantyProductRegistrationContainerModel>> {
    let url = this.apiUrl;
    if (this.endpoint_path && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.delete<ApiResponseModel<WarrantyProductRegistrationContainerModel>>(
      url + '/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public printJasperPdfFileLoginEntity(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    visa: ApiVisa,
    customParam?: string): Observable<Blob> {
    let params;
    if (customParam) {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid)
        .set('customParam', customParam);
    } else {
      params = new HttpParams()
        .set('printServiceClassName', printServiceClassName)
        .set('printableFormatHdrGuid', printableFormatGuid);
    }
    let url = this.apiUrl;
    if (this.endpoint_path_login_url && visa.api_domain_url) {
      url = visa.api_domain_url + this.endpoint_path_login_url;
    }
    return this.httpClient.get<Blob>(
      url + '/print-jasper-pdf/' + guid,
      this.getHttpHeaderBlob(visa, params)
    );
  }
}
